'use strict';
var monitoringDetailWindowTpl = require('./detail-window.html');

module.exports = /*@ngInject*/ ["$uibModal", function DetailWindowFactory($uibModal) {

    return {
        openModal: openModal
    };

    /*
    FUNCTIONS
    */
    function openModal(train, investigateTrainFn, closingFn) {
        var modal = $uibModal.open({
            template: monitoringDetailWindowTpl,
            controller: "DetailWindowMonitoringController as vm",
            size: 'lg',
            resolve: {
                train: function () {
                    return train;
                }
            }
        });

        modal.result.then(function () {
            investigateTrainFn(train);
        }, function () {
            closingFn(train);
        });
    }
}];
